import { render, staticRenderFns } from "./records-list.vue?vue&type=template&id=c5830cb6&scoped=true"
import script from "./records-list.vue?vue&type=script&lang=js"
export * from "./records-list.vue?vue&type=script&lang=js"
import style0 from "./records-list.vue?vue&type=style&index=0&id=c5830cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5830cb6",
  null
  
)

export default component.exports